import PropTypes from 'prop-types';
import useBrandContext from 'Contexts/brand-context';
import Description from 'Shared/components/description';
import InlineSvg from 'Shared/components/inline-svg';
import styles from './empty-state-description.css';


const renderPointItem = (text) => (
  <div className={styles.pointContainer}>
    <InlineSvg src="/check-mark.svg" />
    <div className={styles.pointText}>
      {text}
    </div>
  </div>
);


const EmptyStateDescription = ({
  translations: t,
  introductionText,
  className,
}) => {
  const { brandData } = useBrandContext();

  const isFinanceLink = (brandData.name === 'FinanceLink');

  return (
    <div className={className || ''}>
      <Description text={introductionText} />
      <div className={styles.pointsContainer}>
        {renderPointItem(t.point_track_invoices)}
        {!isFinanceLink && renderPointItem(t.point_apply_business_loans)}
        {renderPointItem(t.point_export_transactions)}
        {!isFinanceLink && renderPointItem(t.point_benefits_overview)}
        {!isFinanceLink && renderPointItem(t.point_erp_integration)}
        {renderPointItem(t.point_chat)}
      </div>
      <Description text={t.closing_words} />
    </div>
  );
};

EmptyStateDescription.propTypes = {
  translations: PropTypes.object.isRequired,
  introductionText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default EmptyStateDescription;
